import React from 'react';
import { FormattedMessage } from 'react-intl';
import '../../../../public/css/demo.css';
import '../../../../public/css/style.css';
import NutritionalIcon from '../items/components/NutritionalIcon';
import defaultMsg from '../../../../translations/lang/en-US.json';

class Legend extends React.Component {
  render() {
    return (
      <div className="row legend" id="healthy-icons">
        <div className="col-sm-12">
          <div className="row row-fluid">
            <div className=" col-xs-12 col-md-4  column" />
            <div className=" col-xs-12 col-md-8  column">
              {this.props.active.dairy ? (
                <span className="legendItem">
                  <NutritionalIcon status={1} type="dairy" />
                  &nbsp;
                  <span className="nutritional-text">
                    <FormattedMessage
                      id="containsDairy"
                      defaultMessage={defaultMsg.containsDairy}
                    />
                  </span>
                </span>
              ) : null}

              {this.props.active.gluten ? (
                <span className="legendItem">
                  <NutritionalIcon status={1} type="gluten" />
                  &nbsp;
                  <span className="nutritional-text">
                    <FormattedMessage
                      id="containsGluten"
                      defaultMessage={defaultMsg.containsGluten}
                    />
                  </span>
                </span>
              ) : null}
              {this.props.active.heartHealty ? (
                <span className="legendItem ">
                  <NutritionalIcon status={1} type="heart" />
                  &nbsp;
                  <span className="nutritional-text">
                    <FormattedMessage
                      id="heartHealthy"
                      defaultMessage={defaultMsg.heartHealthy}
                    />
                  </span>
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/orderType/Legend.jsx